import React from "react";
import {Col, Container, Row, Spinner} from "react-bootstrap";

const LoadingSpinner = () => {

    return (
        <Container>
            <Row className={'row-height'}>
                <Col  className='content-left-wrapper' >
                    <Container fluid className="text-black">
                        <Spinner />
                    </Container>
                </Col>
            </Row>
        </Container>
    );
}

export default LoadingSpinner;
